import { GroupTreeItem, VariableApiError, VariableTreeItem, VariableType } from '@selfai-platform/pipeline-common';
import { NewGroupItem, NewTreeItem, NewVariableItem, TreeDataItem } from '../models';

export function isGroup(item: TreeDataItem): item is GroupTreeItem {
  return ('variables' in item || !('value' in item)) && !isNewItem(item);
}

export function isVariable(item: TreeDataItem): item is VariableTreeItem {
  return 'value' in item && !isNewItem(item);
}

export function isNewItem(item: TreeDataItem): item is NewTreeItem {
  return 'isNewItem' in item && !!item.isNewItem;
}

export function isNewVariableItem(item: TreeDataItem): item is NewVariableItem {
  return isNewItem(item) && item.type === VariableType.VARIABLE;
}

export function isNewGroupItem(item: TreeDataItem): item is NewGroupItem {
  return isNewItem(item) && item.type === VariableType.GROUP;
}

export function isVariableType(item: TreeDataItem): boolean {
  if (isNewItem(item)) {
    return item.type === VariableType.VARIABLE;
  }

  return isVariable(item);
}

export function isGroupType(item: TreeDataItem): boolean {
  if (isNewItem(item)) {
    return item.type === VariableType.GROUP;
  }

  return isGroup(item);
}

export function isVariableError(error: unknown): error is VariableApiError {
  return (
    error &&
    typeof error === 'object' &&
    typeof (error as VariableApiError).code === 'string' &&
    typeof (error as VariableApiError).message === 'string' &&
    typeof (error as VariableApiError).title === 'string' &&
    typeof (error as VariableApiError).id === 'string' &&
    typeof (error as VariableApiError).details === 'object'
  );
}
